import { render } from "./QuizGameRas.vue?vue&type=template&id=6039079c&scoped=true"
import script from "./QuizGameRas.vue?vue&type=script&lang=js"
export * from "./QuizGameRas.vue?vue&type=script&lang=js"

import "./QuizGameRas.vue?vue&type=style&index=0&id=6039079c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6039079c"]])

export default __exports__